package com.milta.feature.imports.domain.usecase

import com.milta.feature.imports.domain.entity.ImportPdfResult
import com.milta.feature.imports.domain.repository.ImportPdfRepository

/** POST /api/v1/imports/pdf (MIL-26, écran "Analyse en cours"). */
class ExtractDeliveriesFromPdfUseCase(private val repository: ImportPdfRepository) {
    suspend operator fun invoke(fileBytes: ByteArray, fileName: String): ImportPdfResult =
        repository.extractDeliveriesFromPdf(fileBytes, fileName)
}
